"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavPill = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["list", "children"];
var NavPillPanel = _styledComponents["default"].div.withConfig({
  displayName: "NavPill__NavPillPanel",
  componentId: "sc-147b9yy-0"
})(["color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textBase));
/**
 * @deprecated
 * This component will be archived soon.
 * Please use the Tabs component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navpill--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavPill)
 **/
var NavPill = exports.NavPill = function NavPill(_ref) {
  var list = _ref.list,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("section", Object.assign({}, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.NavPill
  }), list, /*#__PURE__*/_react["default"].createElement(NavPillPanel, null, children));
};